import Vue from "vue";
import Toastify from "./Toast.vue";

export const showToast = (variant, message, timeout) => {
  const content = {
    component: Toastify,
    props: {
      variant: variant,
      message: message,
    },
  };

  Vue.$toast(content, {
    timeout: timeout || 5000,
    position: "top-right",
    toastClassName: "custom-toast-component",
  });
};
